module.exports = __webpack_public_path__ + "static/img/华为 HUAWEI MatePad Pro.ad645244.png";